import { post } from './client';
import { buildPath } from './utils';
import { MIXPANEL_PATH } from './constants';

export const trackPageView = (options: any): Promise<any> => post(buildPath(MIXPANEL_PATH), options);
